module.exports = __webpack_public_path__ + "img/legal_support.4b722416.jpeg";